import axios from 'axios'
import type { GroupItem, Item } from 'BrokerTsLib/src/dtos'
import { longStaleTime } from 'BrokerTsLib/src/hooks'
import { returnArray } from 'BrokerTsLib/src/Utils/reactQueryUtils'
import type { UseQueryResult } from 'react-query'
import { useQuery } from 'react-query'

import type { GenericQueryOptions} from '.'
import { useUrl } from '.'


export const useGetRisks = (options?: GenericQueryOptions<GroupItem[]>): UseQueryResult<GroupItem[], any> => {
  const url = useUrl()

  return useQuery({
    queryKey: ['GetRisks', 'travel'],
    queryFn: () => axios.get<Item[]>(`${url}/GetRisks`).then(returnArray),
    staleTime: longStaleTime,
    ...options
  })
}

export const useGetGroupedRisks = () => {
  const { data } = useGetRisks({ refetchOnWindowFocus: false, refetchOnMount: false })

  return data?.reduce((pv, cv) => {
    return { ...pv, [cv.groupId ?? '']: [...(pv[cv.groupId ?? ''] ?? []), cv] }
  }, {} as { [n: string]: GroupItem[] })
}